module.exports = __webpack_public_path__ + "img/preloader-theme.e2bdd943.svg";